import {NavigationItemConfigType} from '../routing-type';

/**
 * Whether {@link buildMenuItemsFromNavigationConfig} with includeOnlyRoutes: false
 * would render any child rows (isOnlyRoute entries are omitted from the sidebar).
 */
export function navigationItemHasVisibleSidebarChildren(item: NavigationItemConfigType): boolean {
    return item.children?.some((child) => !child.isOnlyRoute) ?? false;
}
